import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import {
    BlockQuickLinkDisplayVariant,
    QuickLinkCardData,
} from '@telialt/core-cms-content/src/components/BlockQuickLink/model';

import { Subcategory } from '../../../models';
import { QuickLinkCardsSection } from './SubcategoryCards.styles';

type Props = { subcategories: Subcategory[] };
export const SubcategoryCards: FC<Props> = ({ subcategories }) => {
    const { t } = useTranslations();

    if (!subcategories?.length) {
        return null;
    }

    const displayVariant: BlockQuickLinkDisplayVariant = 'card-image';
    const sectionTitle = t['eshop.categoryList.ariaLabel'];

    const cards = subcategories.map(
        (s): QuickLinkCardData => ({
            id: s.code,
            title: s.name,
            url: s.url,
            image: { src: s.image?.url, alt: s.image?.alt || '' },
            displayVariant,
            colorVariant: 'primary',
        }),
    );

    return (
        <QuickLinkCardsSection
            cards={cards}
            displayVariant={displayVariant}
            ariaLabel={sectionTitle}
            dataSectionName={sectionTitle}
        />
    );
};
